import React, { useMemo } from "react";

import { useFilterLayers } from "fond/hooks/useFilterLayers";

import { LayerFilterContext } from "./LayerFilterContext";

interface LayerFilterProviderProps {
  defaultValues?: Record<string, string[]>;
  versionId: string;
  children: React.ReactNode;
  skipConfigUpdate?: boolean;
}

const LayerFilterProvider: React.FC<LayerFilterProviderProps> = ({
  defaultValues = {},
  versionId,
  children,
  skipConfigUpdate,
}: LayerFilterProviderProps): React.ReactNode => {
  const { filters, onChange } = useFilterLayers(versionId, defaultValues, skipConfigUpdate);

  const value = useMemo(
    () => ({
      filters,
      onChange,
    }),
    [filters, onChange]
  );

  return <LayerFilterContext.Provider value={value}>{children}</LayerFilterContext.Provider>;
};

export default LayerFilterProvider;
